import { t } from "i18next"
import { timestraptoIOStime } from "../Converter"

/**
 * @param currentLangID
 * @param data:{
 *     parent : {
 *         name: "KOL",
 *         path: "list" // without :lang
 *     },
 *     child : {
 *          name: "Happy",
 *          path: "p/132214" // without :lang
 *     }
 * }
 * @returns {{itemListElement: [{item: {"@type": string, name: string, "@id": string}, "@type": string, name: string, position: number}, {item: {"@type": string, name: *, "@id": string}, "@type": string, name: (string|*|string), position: number}, {item: {"@type": string, name, "@id": string}, "@type": string, name, position: number}], "@type": string, "@context": string}}
 */

export function returnBreadcrumbList(currentLangID, data) {
  try {
    return {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Look4KOL",
          item: "https://look4kol.com",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Profile",
          item: "https://look4kol.com" + currentLangID + "/s",
        },
        {
          "@type": "ListItem",
          position: 3,
          name: data.child.name,
          item: "https://look4kol.com/" + currentLangID + "/" + data.child.path,
        },
      ],
    }
  } catch (err) {
    console.log(err)
  }
}

export function returnNewArticle(currentLangID, data) {
  try {
    // return {
    //     "@context": "https://schema.org",
    //     "@type": "NewsArticle",
    //     "image": [
    //         data.featureImage
    //     ],
    //     "url": "https://look4kol.com/data/" + data.id,
    //     "dateCreated": timestraptoIOStime(typeof data.createDate.seconds !== 'undefined' ? data.createDate.seconds : data.createDate._seconds),
    //     "datePublished": timestraptoIOStime(data.hasOwnProperty('publishDate') ?
    //         typeof data.publishDate.seconds !== 'undefined' ?
    //             data.publishDate.seconds : data.publishDate._seconds :
    //         typeof data.createDate.seconds !== 'undefined' ?
    //             data.createDate.seconds : data.createDate._seconds
    //     ),
    //     "dateModified": timestraptoIOStime(typeof data.lastModified.seconds !== 'undefined' ?  data.lastModified.seconds : data.lastModified._seconds),
    //     "headline": (data, userLang),
    //     "name": (data, userLang),
    //     "description": dataContentLangWithLimit(data, userLang),
    //     // "keywords": t("HomePage.keywords"),
    //     "author": {
    //         "@type": "Person",
    //         "name": data.createUserID,
    //         "url": "https://Look4KOL.com/profile/" + data.createUserID,
    //     },
    //     "creator": {
    //         "@type": "Organization",
    //         "name": "Look4KOL",
    //     },
    //     "publisher": {
    //         "@type": "Organization",
    //         "name": "Look4KOK - 找尋你的KOL",
    //         "logo": {
    //             "@type": "ImageObject",
    //             "url": "https://Look4KOL.com/logo.png"
    //         }
    //     },
    //     "mainEntityOfPage": {
    //         "@type": "WebPage",
    //         "@id": "https://Look4KOL.com/data/" + data.id
    //     },
    //     "dataBody": dataContentLangWithLimit(data, userLang),
    //     "genre": 'education',
    // };
  } catch (err) {
    console.log(err)
  }
}
